import TB from '@tiger/bridge';
import { Button } from 'antd';
import React from 'react';
import { CardButtonWrap } from 'components/Card';
import Track from 'components/Track';
import APP from 'stores/APP';
import { eventName, eventType } from '../../helper';
import { SecurityActionType } from '../../type';
import './style.scss';

const tips: Record<Exclude<SecurityActionType, 'bindEmail' | 'bindPhone' | 'linkAccount' | 'mfaEnable'>, string> = {
    modifyEmail: __('您的邮箱已修改成功'),
    modifyPassword: __('您的密码已修改'),
    upgradePassword: __('您的密码已更新'),
    modifyPhone: __('您的手机号已修改成功'),
    activeEmail: __('您的邮箱已激活，可直接使用邮箱作为TradeUP登录名')
};

const ModifySuccess: React.FC<{ type: keyof typeof tips }> = ({ type }) => {
    const link = () => {
        if (APP.isTiger && window.TigerBridge.quit) {
            TB.quit();
        } else {
            window.location.href = '/logout?next=/login';
        }
    };

    return (
        <div className="security-success">
            <p>{tips[type]}</p>
            <CardButtonWrap>
                <Track eventModel="安全中心" eventType={eventType[type]} eventName={`${eventName[type]}_下一步3`}>
                    <Button block size="large" type="primary" onClick={link}>
                        {__('完成，请重新登录')}
                    </Button>
                </Track>
            </CardButtonWrap>
        </div>
    );
};

export default ModifySuccess;
